/* Vapor Wishlist — gestión local en localStorage. */
(function () {
  'use strict';
  var KEY = 'vapor_wishlist_v1';
  var listeners = [];
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    emit();
  }
  function emit() {
    var list = read();
    listeners.forEach(function (fn) {
      try { fn(list); } catch (e) {}
    });
    document.dispatchEvent(new CustomEvent('vapor:wishlist:change', {
      detail: { list: list, count: list.length }
    }));
  }
  function add(handle) {
    if (!handle) return;
    var list = read();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      write(list);
    }
  }
  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }
  function toggle(handle) {
    if (has(handle)) { remove(handle); return false; }
    add(handle);
    return true;
  }
  function has(handle) {
    return read().indexOf(handle) !== -1;
  }
  function list() { return read().slice(); }
  function count() { return read().length; }
  function on(event, fn) {
    if (event === 'change' && typeof fn === 'function') {
      listeners.push(fn);
    }
  }
  /* Aplica estado a todos los botones presentes en la página */
  function refreshButtons() {
    var btns = document.querySelectorAll('[data-vapor-wishlist-btn]');
    btns.forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var on = handle && has(handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', !!on);
    });
  }
  /* Click handler delegado */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vapor-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var nowOn = toggle(handle);
    btn.classList.remove('vapor-heart--beat');
    void btn.offsetWidth;
    if (nowOn) btn.classList.add('vapor-heart--beat');
    refreshButtons();
  });
  /* Actualizar contador del header */
  function refreshCounter() {
    var n = count();
    var els = document.querySelectorAll('[data-vapor-wishlist-count]');
    els.forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  document.addEventListener('vapor:wishlist:change', function () {
    refreshButtons();
    refreshCounter();
  });
  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons();
    refreshCounter();
  });
  window.VaporWishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    list: list,
    count: count,
    on: on,
    refresh: function () { refreshButtons(); refreshCounter(); }
  };
})();
